import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DimensionsService {
  private dimensionsData:BehaviorSubject<{ height:0,width:0} | null>;
  public dimensionObj:Observable<{ height:0,width:0} | null>;

  constructor() {
    this.dimensionsData = new BehaviorSubject({
      height: 0,
      width: 0
    });

    this.dimensionObj = this.dimensionsData.asObservable();

   }

   public get dimensionValue() {
    return this.dimensionsData.value;
   }
 
   public setDimensions(data:any) {
    this.dimensionsData.next(data);
   }
}
